// 只、具、株、根、枝、
// 面、张、颗、粒、方、
// 朵、轮、部、台、堂、
// 节、盘、贴、顶、扇、
// 处、辆、架、副、件、
// 封、幅、本、发、门、
// 盏、口、股，

export function Unit(unit, cartType) {
  let obj = {}
  switch (unit) {
    // 只、具、株、根、枝、
    case '只':
    case '具':
    case '株':
    case '根':
    case '枝':

    // 面、张、颗、粒、方、
    // eslint-disable-next-line no-fallthrough
    case '面':
    case '张':
    case '颗':
    case '粒':
    case '方':

    // 朵、轮、部、台、堂、
    // eslint-disable-next-line no-fallthrough
    case '朵':
    case '轮':
    case '部':
    case '台':
    case '堂':

    // 节、盘、贴、顶、扇、
    // eslint-disable-next-line no-fallthrough
    case '节':
    case '盘':
    case '贴':
    case '顶':
    case '扇':

    // 处、辆、架、副、件、
    // eslint-disable-next-line no-fallthrough
    case '处':
    case '辆':
    case '架':
    case '副':
    case '件':

    // 封、幅、本、发、门、
    // eslint-disable-next-line no-fallthrough
    case '封':
    case '幅':
    case '本':
    case '发':
    case '门':

    // 盏、口、股，
    // eslint-disable-next-line no-fallthrough
    case '盏':
    case '口':
    case '股':
    // eslint-disable-next-line no-fallthrough
    case '支':
    case '卷':
    case '个':
    case '套':
    case '棵':
    // eslint-disable-next-line no-fallthrough
    case '墩':
    case '片':
    case '瓶':
    case '袋':
    case '块':

    // eslint-disable-next-line no-fallthrough
    case '桶':
    case '把':
    case '组':
    case '捆':
    case '包':

    // eslint-disable-next-line no-fallthrough
    case '箱':
    case '樘':
      obj.max = 99999999999
      obj.min = 1
      obj.precision = 0
      break
    case '升':
    case '吨':
    case '千克':
    case '米':
    case '立方米':
    case '平方米':
      // if(cartType === 1){
      //   obj.max = 9999.99
      //   obj.min = 1
      // }else{
      //   obj.max = 999999.999
      //   obj.min = 0.001
      // }
      obj.max = 999999.99
      obj.min = 0.01
      obj.precision = 3
      break

    // obj.max = 999999.99
    // obj.min = 0.01
    // obj.precision = 2
    // break
    default:
      break
  }
  return obj
}
